import { render, staticRenderFns } from "./icon-side-base.vue?vue&type=template&id=2005db49&"
import script from "./icon-side-base.vue?vue&type=script&lang=ts&"
export * from "./icon-side-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports